"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Resolver = void 0;
const ens_resolver_provider_1 = require("../resolver-providers/providers/ens/ens-resolver-provider");
const freename_resolver_provider_1 = require("../resolver-providers/providers/freename/freename-resolver-provider");
const ud_resolver_provider_1 = require("../resolver-providers/providers/ud/ud-resolver-provider");
const resolver_1 = require("../resolvers/resolver");
class Web3Resolver extends resolver_1.Resolver {
    constructor(connectionLibrary) {
        const freenameResolverProvider = new freename_resolver_provider_1.FreenameResolverProvider({ connectionLibrary: connectionLibrary });
        const udResolverProvider = new ud_resolver_provider_1.UDResolverProvider({ connectionLibrary: connectionLibrary });
        const ensResolverProvider = new ens_resolver_provider_1.ENSResolverProvider({ connectionLibrary: connectionLibrary });
        super([freenameResolverProvider, udResolverProvider, ensResolverProvider]);
    }
}
exports.Web3Resolver = Web3Resolver;
